import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProviderBenefitPage.scss';
import { Typography } from 'src/latest/src';
import PersonWithCalendar from '../../../../assets/icons/icon-schedule-user.svg';
import AutomaticPatientOnboarding from '../../../../assets/icons/icon-automatic-patient.svg';
import ViableMatch from '../../../../assets/icons/icon-viable-match.svg';
import RevenueIcon from '../../../../assets/icons/icon-revenue.svg';

// The refactored FeatureCard component
interface FeatureCardProps {
  title: string;
  description: string;
  photoUrl: string;
  iconClass: string;
  borderClass: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  photoUrl,
  iconClass,
  borderClass,
}) => (
  <div className="">
    <div className={`h-100 p-4 bg-white feature-card ${borderClass}`}>
      <div className={`icon-wrapper ${iconClass}`}>
        <img src={photoUrl} alt={title} />
      </div>
      <div className="feature-content">
        <Typography
          className="feature-title mb-3"
          variant="size-16"
          weight="medium"
        >
          {title}
        </Typography>
        <p className="feature-description">{description}</p>
      </div>
    </div>
  </div>
);

export default function ProviderBenefitPage() {
  const { t } = useTranslation('providerBenefit');

  // Data array for the cards
  const features = [
    {
      title: t('setScheduleTitle'),
      description: t('setScheduleDescription'),
      photoUrl: PersonWithCalendar,
      iconClass: 'icon-calendar',
      borderClass: 'border-calendar',
    },
    {
      title: t('automaticOnboardingTitle'),
      description: t('automaticOnboardingDescription'),
      photoUrl: AutomaticPatientOnboarding,
      iconClass: 'icon-user',
      borderClass: 'border-user',
    },
    {
      title: t('guaranteedMatchTitle'),
      description: t('guaranteedMatchDescription'),
      photoUrl: ViableMatch,
      iconClass: 'icon-check',
      borderClass: 'border-check',
    },
    {
      title: t('deliverCareTitle'),
      description: t('deliverCareDescription'),
      photoUrl: RevenueIcon,
      iconClass: 'icon-arrow',
      borderClass: 'border-arrow',
    },
  ];

  return (
    <div className="provider-benefit-page">
      <div className="provider-benefit-container">
        {/* Header Section */}

        {/* Dynamic Grid Rendering */}
        <div className="provider-benefit-grid">
          {features.map((item, index) => (
            <FeatureCard key={index} {...item} />
          ))}
        </div>

        {/* Mission Section */}
      </div>
    </div>
  );
}
